import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import { TokenAmount, useAsyncEffect } from '@xylabs/sdk-react'
import { Quadkey } from '@xyo-network/sdk-xyoworld-js'
import BigNumber from 'bn.js'
import { useState } from 'react'

import { useAuction } from '../Contexts'

interface Props {
  onClose?: () => void
  open?: boolean
  quadkey?: Quadkey
}

const DialogOpen: React.FC<Props> = (props) => {
  const { quadkey, onClose, open = false } = props
  const { auction } = useAuction(quadkey)

  const onMintClicked = async (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.stopPropagation()
    await auction?.actions.mint()
    onClose?.()
  }

  const [dutchAuctionPrice, setDutchAuctionPrice] = useState<BigNumber>()
  const [canMint, setCanMint] = useState<boolean>()

  useAsyncEffect(
    // eslint-disable-next-line react-hooks/exhaustive-deps
    async (isMounted) => {
      if (auction) {
        const canMint = await auction.fetchDutchAuctionActive()
        const dutchAuctionPrice = await auction.fetchDutchAuctionPrice()
        if (!isMounted()) return
        setCanMint(canMint)
        setDutchAuctionPrice(dutchAuctionPrice)
      }
    },
    [auction],
  )

  if (auction) {
    return (
      <Dialog
        onClose={() => {
          onClose?.()
        }}
        open={open}
      >
        <DialogTitle>Mint Dutch Auction</DialogTitle>
        <DialogContent>
          <Box display="flex" flexDirection="column">
            <Box>
              <Typography component={Box} variant="body2">
                Mint geotoken for Dutch Auction Price
                <ul>
                  <li>Minting reward (10% of price) goes to you</li>
                  <li>Minted token is sent to the buyer</li>
                  <li>Four child geotoken auctions are started</li>
                </ul>
              </Typography>
            </Box>
            <TokenAmount amount={dutchAuctionPrice} label="Price" />
          </Box>
        </DialogContent>
        <DialogActions>
          <Box display="flex" width="100%">
            <Box>
              <Button
                onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
                  event.stopPropagation()
                  onClose?.()
                }}
                variant="text"
              >
                Close
              </Button>
            </Box>
            <Box flexGrow={1}></Box>
            <Box>
              <Button disabled={!canMint} onClick={onMintClicked} variant="text">
                Mint
              </Button>
            </Box>
          </Box>
        </DialogActions>
      </Dialog>
    )
  }
  return null
}

const MintDutchDialog: React.FC<Props> = (props) => {
  const { open } = props
  if (open) {
    return <DialogOpen {...props} />
  } else {
    return null
  }
}

export default MintDutchDialog
